import axios from "../../axios.js";
import { createRequestSequence } from "../requestSequence";

const allPaymentsSeq = createRequestSequence();
const allPayoutsSeq = createRequestSequence();

const getPayments = ({ commit }, data) => {
  const filter = `filter=${data.search_param || ""}&`;
  const sortBy = `sort_by=${data.sort_by || ""}&`;
  const sort = `sort=${data.sort_type || "ASC"}&`;

  const page_number =
    data.page_number !== null ? `page_number=${data.page_number}&` : "";
  const on_page = data.on_page !== null ? `on_page=${data.on_page}&` : "";
  let url = "api/payment/all?" + filter + sortBy + sort + page_number + on_page;
  url = url.slice(0, -1);
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  axios
    .get(url, config)
    .then((response) => {
      commit("SET_PAYMENTS", response.data);
      commit("SET_PAYMENTS_PAGINATION", {
        page_number: data.page_number,
        on_page: data.on_page,
      });
      commit("SET_PAYMENTS_ERROR", false);
    })
    .catch((err) => {
      console.log(err.response.data);
      commit("SET_PAYMENTS_ERROR", err);
    });
};

const setPaymentsToNull = ({ commit }) => {
  commit("SET_PAYMENTS_TO_NULL", null);
};

const clearAllPayments = ({ commit }) => {
  allPaymentsSeq.invalidate();
  commit("CLEAR_ALL_PAYMENTS");
};

const getAllPayments = async ({ commit }, data) => {
  let payment_type = "";

  let user_param;
  if (data.phone) {
    user_param = data.phone ? `user_param=${data.phone}` : "";
  } else if (data.search_param) {
    user_param = data.search_param ? `user_param=${data.search_param}` : "";
  } else {
    user_param = data.custom_search_param
      ? `user_param=${data.custom_search_param}`
      : "";
  }

  const phone = data.phone ? `phone=${data.phone}&` : "";

  const page_number = data.page_number
    ? `page_number=${data.page_number}&`
    : "";
  const on_page = data.on_page ? `on_page=${data.on_page}&` : "";
  if (data.third_filter_param && data.third_filter_param !== "all") {
    payment_type = `payment_type=${data.third_filter_param}&`;
  }
  const filter_param = data.filter_param
    ? `filter_param=${data.filter_param}&`
    : "";
  const list_type = data.second_filter_param
    ? `list_type=${data.second_filter_param}&`
    : `list_type=payments_users&`;

  let url =
    "api/admin/all-payments?" +
    list_type +
    payment_type +
    phone +
    page_number +
    on_page +
    filter_param +
    user_param;
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const requestId = allPaymentsSeq.next();
  await axios
    .get(url, config)
    .then((response) => {
      if (!allPaymentsSeq.isLatest(requestId)) return;
      commit("SET_ALL_PAYMENTS", response.data);
      commit("SET_ALL_PAYMENTS_PAGINATION", {
        page_number: response.data.page_number,
        on_page: response.data.on_page,
        total: response.data.total,
      });
      commit("SET_ALL_PAYMENTS_ERROR", false);
    })
    .catch((err) => {
      if (!allPaymentsSeq.isLatest(requestId)) return;
      console.log(err.response.data);
      commit("SET_ALL_PAYMENTS_ERROR", err);
    });
};

const fetchAllPayouts = async ({ commit }, data) => {
  const filter =
    data.search_param && data.search_param !== "ALL"
      ? `filter_param=${data.search_param || ""}&`
      : "";
  const page_number = data.page_number
    ? `page_number=${data.page_number}&`
    : "";
  const on_page = data.on_page ? `on_page=${data.on_page}&` : "";
  const status =
    data.filter_param && data.filter_param !== "ALL"
      ? `status=${data.filter_param}&`
      : "";
  const date_from = data.date_from ? `date_from=${data.date_from}&` : "";
  const date_to = data.date_to ? `date_to=${data.date_to}&` : "";
  let url =
    "api/withdraw/all?" +
    filter +
    page_number +
    on_page +
    status +
    date_from +
    date_to;
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  const requestId = allPayoutsSeq.next();
  await axios
    .get(url, config)
    .then((response) => {
      if (!allPayoutsSeq.isLatest(requestId)) return;
      commit("SET_ALL_PAYOUTS", response.data);
      commit("SET_ALL_PAYOUTS_ERROR", false);
    })
    .catch((err) => {
      if (!allPayoutsSeq.isLatest(requestId)) return;
      console.log(err.response.data);
      commit("SET_ALL_PAYOUTS_ERROR", err);
    });
};

const getUserPayments = ({ commit }, data) => {
  const url = `api/payment/${data.userId}`;
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  axios
    .get(url, config)
    .then((response) => {
      commit("SET_USER_PAYMENTS", response.data);
      commit("SET_USER_PAYMENTS_ERROR", false);
    })
    .catch((err) => {
      console.log(err.message);
      commit("SET_USER_PAYMENTS_ERROR", err);
    });
};

const fetchNumberOfWaitingWithdraws = ({ commit }) => {
  const url = `/api/withdraw/waitingPaymentsNumber`;
  axios
    .get(url)
    .then((response) => {
      commit("SET_NUMBER_OF_WAITING_MESSAGES", response.data);
    })
    .catch((err) => console.log(err));
};

const setCounterWaitingWithdraws = ({ commit }, number) => {
  commit("SET_NUMBER_OF_WAITING_MESSAGES", number);
};
const downloadPaymentsXls = async ({ commit }, data) => {
  console.log(data);
  const type = data.filterParam ? data.filterParam : "payments_users";
  const userPhone = data.searchParam ? data.searchParam : "";
  const params = {};
  if (type) {
    params.list_type = type;
  }
  if (userPhone) {
    params.userPhone = userPhone;
  }
  const url = `api/admin/all-payments/file`;
  axios(url, {
    params,
    method: "GET",
    headers: {
      "Content-Disposition": "attachment; filename=payments.xls",
      "Content-Type":
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    },
    responseType: "blob",
  })
    .then((response) => {
      const fileURL = window.URL.createObjectURL(new Blob([response.data]));
      const fileLink = document.createElement("a");

      fileLink.href = fileURL;
      fileLink.setAttribute("download", "platnosci.xls");
      document.body.appendChild(fileLink);
      fileLink.click();
      commit("SET_DOWNLOAD_MESSAGE", true);
    })
    .catch((err) => console.log(err.response));
};

export default {
  getPayments,
  getUserPayments,
  getAllPayments,
  fetchAllPayouts,
  setPaymentsToNull,
  clearAllPayments,
  fetchNumberOfWaitingWithdraws,
  downloadPaymentsXls,
  setCounterWaitingWithdraws,
};
